import {classNames} from 'utils';
import {Color, cssColorValues} from './colors';
import styles from './progress_bar.module.css';

export const ProgressBar = ({progress, color = 'blue', size = 'sm'}: Props) => {
  let background: Color;
  if (color === 'dynamic') {
    if (progress < 0.2) background = 'red';
    else if (progress < 0.4) background = 'orangeLight';
    else if (progress < 0.6) background = 'orange';
    else if (progress < 0.8) background = 'blueLight';
    else background = 'blue';
  } else {
    background = color;
  }

  return (
    <div className={classNames([styles.track, styles[size]])}>
      <div
        className={classNames([styles.progress, styles[size]])}
        style={{width: `${Math.min(progress * 100, 100)}%`, background: cssColorValues[background]}}
      />
    </div>
  );
};

type Props = {
  progress: number;
  color?: Color | 'dynamic';
  size?: 'sm' | 'md' | 'lg';
};
